import Typography from '@mui/material/Typography';
import React from 'react';
import {Stack} from '@mui/material';
import {TruvuDialog} from '../../../components/dialog/TruvuDialog';
import {CancelRounded} from '@mui/icons-material';
import {TruvuButton} from '../../../components/button/TruvuButton';

interface TourErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TourErrorDialog(props: TourErrorDialogProps) {
  return (
    <TruvuDialog {...props}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Typography variant="h1">Failed to Load</Typography>
        <CancelRounded color="error" sx={{width: '90px', height: '90px'}} />
      </Stack>
      <Stack py={3}>
        <Typography>
          Your tour failed to load. Please refresh and try again.
        </Typography>
      </Stack>
      <Stack
        flex={1}
        spacing={2}
        justifyContent="flex-end"
        direction="column"
        pb={1}
      >
        <TruvuButton
          variant="primary"
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </TruvuButton>
      </Stack>
    </TruvuDialog>
  );
}
